export default __webpack_public_path__ + "static/media/c002-PPII-4.3aebc58b.svg";